import LoginSMSPage from '@/views/login/LoginSMSPage'

export default function Page() {
  return <LoginSMSPage />
}
